import { render, staticRenderFns } from "./XhCertificate2.vue?vue&type=template&id=ae4e0aec"
import script from "./XhCertificate2.vue?vue&type=script&lang=js"
export * from "./XhCertificate2.vue?vue&type=script&lang=js"
import style0 from "./XhCertificate2.vue?vue&type=style&index=0&id=ae4e0aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports